<template>
    <div class="page">
      <v-container fluid>
        <v-form ref="form">
          <v-row class="justify-center mt-3">
            <v-col cols="4">
                <v-text-field
                v-model="form.filters.formacao"
                label="Formação"
                outlined
                dense
                ></v-text-field>
            </v-col>
            <sigfoco-date-picker
                :cols="3"
                label="Data de Realização"
                v-model="form.filters.dataRealizacao"
                removeIcon
                outlined
                dense
            ></sigfoco-date-picker>
            <v-col cols="2">
              <v-autocomplete
                v-model="form.filters.origemId"
                label="Origem"
                outlined
                dense
                :items="form.lists.origens"
                item-text="nome"
                item-value="id"
              />
            </v-col>
            <v-col cols="3">
              <v-autocomplete
                v-model="form.filters.situacao"
                label="Situação"
                outlined
                dense
                :items="opcoesStatus"
                item-text="descricao"
                item-value="value"
                id="situacao"
                hide-details="auto"
              />
            </v-col>
            <sigfoco-date-picker
                ref="dataInicioPicker"
                v-model="form.filters.dataInicio"
                label="Início do Período"
                :cols="2"
                removeIcon
                :dataEdicao="form.filters.dataInicio"
            ></sigfoco-date-picker>
            <sigfoco-date-picker
                ref="dataFimPicker"
                v-model="form.filters.dataFim"
                label="Fim do Período"
                :cols="2"
                removeIcon
                :dataEdicao="form.filters.dataFim"
            ></sigfoco-date-picker>
          </v-row>
          <div class="text-center">
            <v-col cols="12">
              <sigfoco-tooltip
                text="Buscar"
                icon="mdi-magnify"
                @click="buscarHistoricoFormacao()"
              ></sigfoco-tooltip>
              <sigfoco-tooltip
                text="Limpar"
                icon="mdi-eraser"
                @click="resetForm()"
              ></sigfoco-tooltip>
            </v-col>
          </div>
        </v-form>
        <v-data-table
          class="mt-5"
          :headers="table.headers"
          :items="table.itens"
          :items-per-page="10"
          :footer-props="$footerProps"
        >
          <template v-slot:[`item.dataRealizacao`]="{ item }">
            {{ $formatarData(item.dataRealizacao) }}
          </template>
          <template v-slot:[`item.acoes`]="{ item }">
            <sigfoco-tooltip
              text="Visualizar"
              icon="mdi-eye-outline"
              small
              @click="openDialogVisualizarHistoricoFormacao(item)"
            ></sigfoco-tooltip>
            <sigfoco-tooltip
              text="Avaliar Formação"
              icon="mdi-plus-box-multiple-outline"
              small
              v-if="item.avaliacaoId != null && item.situacao == 'Presente'"
              @click="openDialogCadastrarHistoricoFormacao(item)"
            ></sigfoco-tooltip>
          </template>
        </v-data-table>
      </v-container>
      <VisualizarHistoricoFormacaoDialog
        v-if="dialogVisualizarHistoricoFormacao.visible"
        :visible="dialogVisualizarHistoricoFormacao.visible"
        :content="dialogVisualizarHistoricoFormacao.content"
        @onClose="dialogVisualizarHistoricoFormacao.close()"
      ></VisualizarHistoricoFormacaoDialog>
      <CadastrarAvaliacaoFormacaoDialog
        v-if="dialogCadastrarHistoricoFormacao.visible"
        :visible="dialogCadastrarHistoricoFormacao.visible"
        :content="dialogCadastrarHistoricoFormacao.content"
        @onClose="dialogCadastrarHistoricoFormacao.close()"
      ></CadastrarAvaliacaoFormacaoDialog>
    </div>
  </template>
  
  <script>
  import { HistoricoFormacao } from "~/commons/classes/historico-formacao";
  import { Dialog } from "~/commons/classes/dialog";
  import ManterHistoricoFormacaoService from "~/services/manter-historico-formacao.service";
  import ManterSetorService from "~/services/manter-setor.service";
  import VisualizarHistoricoFormacaoDialog from "./dialogs/VisualizarHistoricoDeFormacaoDialog.vue";
  import CadastrarAvaliacaoFormacaoDialog from "./dialogs/CadastrarAvaliacaoFormacaoDialog.vue";

  export default {
    name: "ManterHistoricoDeFormacao",
    mixins: [ManterHistoricoFormacaoService, ManterSetorService],
    components: {
      VisualizarHistoricoFormacaoDialog, CadastrarAvaliacaoFormacaoDialog
    },
    data: () => ({
      dialogVisualizarHistoricoFormacao: Dialog.Build(),
      dialogCadastrarHistoricoFormacao: Dialog.Build(),
      listaDeQuestoes: [],
      form:{
        filters: {
          formacao: null,
          dataRealizacao: null,
          origemId: null,
          dataInicio: null,
          dataFim: null,
          situacao: null,
        },
        lists: {
            origens: [],
        }
      },
      opcoesStatus: [
        { value: true, descricao: "Presente" },
        { value: false, descricao: "Ausente" },
      ],
      table: {
        headers: [
            { text: "Formação", align: "center", value: "formacao" },
            { text: "Data de Realização", align: "center", value: "dataRealizacao" },
            { text: "Origem", align: "center", value: "origem" },
            { text: "Carga Horária", align: "center", value: "cargaHoraria" },
            { text: "Situação", align: "center", value: "situacao", sortable: false },
            { text: "Ações", align: "center", value: "acoes", sortable: false },
        ],
        itens: [],
      }
    }),
    methods: {
      resetForm() {
          this.$resetForm();
          this.form.filters.dataInicio = null;
          this.form.filters.dataFim = null;
          this.form.filters.dataRealizacao = null;  
   
          this.$nextTick(() => {
            this.$set(this.form.filters, 'dataInicio', null);
            this.$set(this.form.filters, 'dataFim', null);
            this.$set(this.form.filters, 'dataRealizacao', null);
          });
          this.table.itens = [];
          this.form.filters.ativo = null;
      },
      openDialogVisualizarHistoricoFormacao(historicoFormacao) {
          this.$visualizar(historicoFormacao.id).then(
          ({ data }) => this.dialogVisualizarHistoricoFormacao.open(new HistoricoFormacao(data.resposta))
          );
      },
      openDialogCadastrarHistoricoFormacao(historicoFormacao) {
          this.$visualizarQuestionarioParticipante(({ params: {avaliacaoId: historicoFormacao.avaliacaoId, formacaoId: historicoFormacao.id} })).then(
          ({ data }) =>{
             historicoFormacao.questoes = data?.lista;
             this.dialogCadastrarHistoricoFormacao.open(new HistoricoFormacao(historicoFormacao))
            }
          );
      },
      buscarHistoricoFormacao() {
        if (!this.validarDatas()) {
            return;
        }
          this.$buscar({ params: this.form.filters }).then(({ data }) => {
            this.table.itens = data.lista;
            }
          );
      },
      validarDatas() {
        if (this.form.filters.dataInicio && this.form.filters.dataFim) {
          if (new Date(this.form.filters.dataInicio) > new Date(this.form.filters.dataFim)) {
            this.$notifyWarning("A data do Início do Período não pode ser maior que a data do Fim do Período.");
            return false;
          }
        }
        return true;
      }
    },
    
    mounted() {
      this.$buscarOrigens().then(({ data }) => {
          this.form.lists.origens = data.itens;
      });
    },
  }
</script>